define([
    'angular',
    './controllers/navigation',
    './controllers/settings',
    './controllers/sites',
    '../services/fileUpload',
    './directives/nav',
    './services/settings',
    './services/site',
    '../directives',
    'ng-file-upload',
], function (angular, navigationCtrl, settingsCtrl, sitesCtrl) {
    'use strict';

    var app = angular
        .module('siteApp', [
            'settingsServices',
            'ui.router',
            'directives',
            'ngFileUpload',
            'fileUploadService',
            'navDirectives',
            'siteServices',
        ])
        // controllers
        .controller(navigationCtrl.name, navigationCtrl.arguments)
        .controller(settingsCtrl.name, settingsCtrl.arguments)
        .controller(sitesCtrl.name, sitesCtrl.arguments)
        // routes
        .config([
            '$stateProvider',
            '$locationProvider',
            function ($stateProvider, $location) {
                $location.html5Mode({
                    enabled: true,
                    requireBase: false,
                });
                $stateProvider
                    .state('settings', {
                        abstract: true,
                        title: 'Settings',
                        views: {
                            'header@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/header.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.city', {
                        url: Routing.generate('settings_city', {
                            _format: 'html',
                        }),
                        title: 'Additional Cities',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/dynamic_city.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.notificationSettings', {
                        url: Routing.generate('notification_settings', {
                            _format: 'html',
                        }),
                        title: 'Notification Settings',
                        views: {
                            'body@': {
                                controller: 'editProfileCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/notification.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.seo', {
                        url: Routing.generate('settings_seo', {
                            _format: 'html',
                        }),
                        title: 'SEO Settings',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/seo.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite', {
                        abstract: true,
                    })
                    .state('settings.microsite.site', {
                        url: Routing.generate('settings_microsite_site', {
                            _format: 'html',
                        }),
                        title: 'Site Configuration',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/site.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite.homepage', {
                        url: Routing.generate('settings_microsite_homepage', {
                            _format: 'html',
                        }),
                        title: 'Microsite Homepage',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/homepage.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite.property_info', {
                        url: Routing.generate(
                            'settings_microsite_property_info',
                            { _format: 'html' }
                        ),
                        title: 'Property Info Page',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/property_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite.contact_info', {
                        url: Routing.generate(
                            'settings_microsite_contact_info',
                            { _format: 'html' }
                        ),
                        title: 'Contact Info Page',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/contact_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite.confirmation', {
                        url: Routing.generate(
                            'settings_microsite_confirmation',
                            { _format: 'html' }
                        ),
                        title: 'Confirmation Page',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/confirmation.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.microsite.content_pages', {
                        url: Routing.generate(
                            'settings_microsite_content_pages',
                            { _format: 'html' }
                        ),
                        title: 'Content Pages',
                        views: {
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/content_pages.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.avmSettings', {
                        abstract: true,
                    })
                    .state('settings.avmSettings.avm', {
                        url: Routing.generate('settings_avm_avm', {
                            _format: 'html',
                        }),
                        title: 'AVM Settings',
                        views: {
                            'header@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/avm_header.html',
                                    }
                                ),
                            },
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/avm.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('settings.avmSettings.report', {
                        url: Routing.generate('settings_avm_report', {
                            _format: 'html',
                        }),
                        title: 'Report Settings',
                        views: {
                            'header@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/report_header.html',
                                    }
                                ),
                            },
                            'body@': {
                                controller: 'settingsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Settings',
                                        template: 'partials/report.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('sites', {
                        url: Routing.generate('get_all_sites', {
                            _format: 'html',
                        }),
                        title: 'My Sites',
                        views: {
                            'header@': {
                                controller: 'sitesCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Site',
                                        template: 'partials/list_header.html',
                                    }
                                ),
                            },
                            'body@': {
                                controller: 'sitesCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Site',
                                        template: 'partials/list.html',
                                    }
                                ),
                            },
                        },
                    });
            },
        ]);
    return app;
});
